import { useEffect, useState } from "react";
import { Loader2, MapPin, Clock, Phone, Mail } from "lucide-react";
import { rePage } from "@/lib/docstate";
import { useDocstate } from "@/context/DocstateContext";
import { EnquiryForm } from "@/components/docstate/EnquiryForm";

export default function DocstateContact() {
  const content = useDocstate();
  const s = content?.settings || {};
  const [page, setPage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    rePage("contact").then(setPage).catch(() => setPage({}));
  }, []);

  if (!page)
    return (
      <div className="ds-bg flex min-h-screen items-center justify-center pt-16">
        <Loader2 className="h-8 w-8 animate-spin text-[#C9A24B]" />
      </div>
    );

  const office = page.office || {};
  const mapQuery = encodeURIComponent(page.map_query || office.address || "Business Bay, Dubai");

  return (
    <div className="ds-bg min-h-screen pt-16" data-testid="docstate-contact">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8 lg:px-12">
        <p className="ds-eyebrow">{page.subtitle || "Get in touch"}</p>
        <h1 className="ds-display mt-2 text-4xl font-medium text-white sm:text-5xl">{page.title || "Contact Docstate"}</h1>
        {page.intro && <p className="mt-4 max-w-2xl text-lg font-light text-[#C9BBB2]">{page.intro}</p>}

        <div className="mt-12 grid gap-10 lg:grid-cols-2">
          <div className="space-y-6">
            <div className="ds-card divide-y divide-[#C9A24B]/10">
              {office.address && (
                <div className="flex items-start gap-3 p-5"><MapPin className="mt-0.5 h-5 w-5 text-[#C9A24B]" /><div><p className="text-sm font-medium text-white">Office</p><p className="text-sm font-light text-[#9D8D83]">{office.address}</p></div></div>
              )}
              {office.hours && (
                <div className="flex items-start gap-3 p-5"><Clock className="mt-0.5 h-5 w-5 text-[#C9A24B]" /><div><p className="text-sm font-medium text-white">Hours</p><p className="text-sm font-light text-[#9D8D83]">{office.hours}</p></div></div>
              )}
              {s.phone && (
                <a href={`tel:${s.phone}`} className="flex items-start gap-3 p-5 transition-colors hover:bg-[#C9A24B]/5" data-testid="contact-phone"><Phone className="mt-0.5 h-5 w-5 text-[#C9A24B]" /><div><p className="text-sm font-medium text-white">Call us</p><p className="text-sm font-light text-[#9D8D83]">{s.phone}</p></div></a>
              )}
              {s.email && (
                <a href={`mailto:${s.email}`} className="flex items-start gap-3 p-5 transition-colors hover:bg-[#C9A24B]/5" data-testid="contact-email"><Mail className="mt-0.5 h-5 w-5 text-[#C9A24B]" /><div><p className="text-sm font-medium text-white">Email</p><p className="text-sm font-light text-[#9D8D83]">{s.email}</p></div></a>
              )}
            </div>
            <iframe
              title="Docstate office location"
              className="h-64 w-full rounded-xl border border-[#C9A24B]/15 grayscale"
              src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
              loading="lazy"
            />
          </div>
          <EnquiryForm kind="contact" subject="Website contact" heading="Send us a message" />
        </div>
      </div>
    </div>
  );
}
